import { Component, ElementRef, Input, OnInit, OnDestroy, NgZone, AfterViewInit, inject } from '@angular/core';
import $ from 'jquery';
import { UiCalendarService } from '../../services/ui-calendar.service';
import AngularHelperService from '../../services/angular-helper.service';
import { Subscription } from 'rxjs';

@Component({
	standalone: true,
	selector: 'ui-calendar',
	template: ``,
})
export class UiCalendarComponent implements OnInit, AfterViewInit, OnDestroy {
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private calendarService: UiCalendarService = inject(UiCalendarService);
	
	@Input() eventSources: any[];
	@Input() calendarWatchEvent: (event: any) => any;
	@Input() calendarId: string;
	@Input() uiConfig: any;
	
	private calendar: any;
	private sources: any[];
	private options: any = null;
	private eventSourcesWatcher: any;
	private eventsWatcher: any;
	private sourcesChanged: boolean = false;
	private defaultConfig: any = {
		calendars: {}
	};
	watcher: any = undefined;
	subscriptions: Array<Subscription> = [];
	
	constructor(private el: ElementRef) {
		
	}

	ngOnInit() {
		this.calendarService.init(this.calendarWatchEvent);

		this.sources = this.eventSources;
		this.sourcesChanged = false;
		this.eventSourcesWatcher = this.calendarService.changeWatcher(
			() => {
				return this.eventSources;
			}, this.calendarService.sourceFingerprint);
		this.eventsWatcher = this.calendarService.changeWatcher(
			() => {
				this.calendarService.allEvents(this.eventSources);
			}, this.calendarService.eventFingerprint
		);
		this.options = {};

		this.getOptions();
		this.bindListeners();
		this.initWatchers();
	}

	ngAfterViewInit() {
		this.calendarService.loadFullCalendar(() => {
			this.initCalendar();
		});
	}

	ngOnDestroy() {
		if (this.watcher) {
			this.angularHelperService.cancelInterval(this.watcher);
		}
		for (var b = 0; b < this.subscriptions.length; b++) {
			this.subscriptions[b].unsubscribe();
		}
		this.destroyCalendar();
	}

	initCalendar() {
		const calendarElement: any = $(this.el.nativeElement);
		this.calendar = calendarElement.fullCalendar(this.options);
		this.calendarService.register(this.calendarId, this.calendar);
		this.angularHelperService.createTimer(() => {
			this.angularHelperService.getWindow().innerWidth <= 700
				? this.calendar.fullCalendar('changeView', 'agendaDay')
				: this.calendar.fullCalendar('changeView', 'agendaWeek');
		});
	}

	getOptions() {
	    var calendarSettings = this.uiConfig ? this.uiConfig : {};
	    var fullCalendarConfig = this.calendarService.getFullCalendarConfig(calendarSettings, this.uiConfig);
	    var localeFullCalendarConfig = this.calendarService.getLocaleConfig(fullCalendarConfig);
		Object.assign(localeFullCalendarConfig, fullCalendarConfig);
		
		this.options = {
		    eventSources : this.eventSources
		};
		Object.assign(this.options, localeFullCalendarConfig);
	    //remove calendars from options
	    this.options.calendars = null;

	    var options2 = {};
	    for (var o in this.options) {
	        if (o !== 'eventSources') {
	            options2[o] = this.options[o];
	        }
	    }
	    return JSON.stringify(options2);
	}

	destroyCalendar() {
		if (this.calendar) {
			this.calendar.fullCalendar('destroy');
		}
		this.calendarService.unregister(this.calendarId);
	}
	
	bindListeners() {
		this.eventSourcesWatcher.onAdded = (source) => {
		    if (this.calendar && this.calendar.fullCalendar) {
		        this.calendar.fullCalendar(this.options);
		        this.calendar.fullCalendar('addEventSource', source);
		        this.sourcesChanged = true;
		    }
		};

		this.eventSourcesWatcher.onRemoved = (source) => {
		    if (this.calendar && this.calendar.fullCalendar) {
		        this.calendar.fullCalendar('removeEventSource', source);
		        this.sourcesChanged = true;
		    }
		};

		this.eventSourcesWatcher.onChanged = () => {
		    if (this.calendar && this.calendar.fullCalendar) {
		        this.calendar.fullCalendar('refetchEvents');
		        this.sourcesChanged = true;
		    }
		};

		this.eventsWatcher.onAdded = (event) => {
		    if (this.calendar && this.calendar.fullCalendar) {
		        this.calendar.fullCalendar('renderEvent', event, !!event.stick);
		    }
		};

		this.eventsWatcher.onRemoved = (event) => {
		    if (this.calendar && this.calendar.fullCalendar) {
		        this.calendar.fullCalendar('removeEvents', event._id);
		    }
		};

		this.eventsWatcher.onChanged = (event) => {
		    if (this.calendar && this.calendar.fullCalendar) {
		        var clientEvents = this.calendar.fullCalendar('clientEvents', event._id);
		        for (var i = 0; i < clientEvents.length; i++) {
		            var clientEvent = clientEvents[i];
		            // clientEvent = this.angularHelperService.extend(clientEvent, event);
					clientEvent = Object.assign(clientEvent, event);
		            this.calendar.fullCalendar('updateEvent', clientEvent);
		        }
		    }
		};
	}
	
	initWatchers() {
		this.subscriptions.push(this.eventSourcesWatcher.subscribe());
		var callback = (newValue, oldValue) => {
			if (this.sourcesChanged === true) {
				this.sourcesChanged = false;
				// return false to prevent onAdded/Removed/Changed handlers from firing in this case
				return false;
			}
			return true;
		};
		this.subscriptions.push(this.eventsWatcher.subscribe(callback));

		var currentOptions = "";
		this.watcher = this.angularHelperService.createInterval(() => {
			var newOptions = this.getOptions();
			if (newOptions !== currentOptions) {
				currentOptions = newOptions;
				this.destroyCalendar();
				this.initCalendar();
			} else if ((newOptions && this.angularHelperService.isUndefined(this.calendar))) {
				currentOptions = newOptions;
				this.initCalendar();
			}
		}, 500);
	}
}
